import { Component, Inject, OnInit } from '@angular/core';
import { AutoEvaluacionComponent } from '../../auto-evaluacion.component';

@Component({
  selector: 'app-diario-seguimiento',
  templateUrl: './diario-seguimiento.component.html',
  styleUrls: ['./diario-seguimiento.component.css']
})
export class DiarioSeguimientoComponent implements OnInit {



  ngOnInit(): void {
  }


  

}
